// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Library from './library'
import store from './store'
import router from './router'

Vue.config.productionTip = false

Vue.use(Library.Plugins.PlasticCollections, { store, router })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
